import { RouteRecordRaw } from 'vue-router';
import login from '../login';
import commesse from '../commesse';
import qrConfigs from '../qrConfigs';
import users from '../users';
import printTemplates from '../printTemplates';
import appConfiguration from '../appConfiguration';
import dashboard from '../dashboard';
import shopOrders from '../shopOrders';
import mailEvents from '../mailEvents';
import pdfInterpolation from '../pdfInterpolation';
import programSubscriptions from '../programSubscriptions';
import profile from '../profile';
import license from '../license';
import additionalItemConfigs from '../additionalItemConfigs';
import shopCategories from '../shopCategories';
import downloads from '../downloads';
import catalogue from '../catalogue';


let routes: RouteRecordRaw[] = [
    {
        path: '/',
        component: () => import("./views/layout.vue"),
        children: [
            ...commesse.routes,
            ...qrConfigs.routes,
            ...users.routes,
            ...printTemplates.routes,
            ...appConfiguration.routes,
            ...dashboard.routes,
            ...shopOrders.routes,
            ...mailEvents.routes,
            ...pdfInterpolation.routes,
            ...programSubscriptions.routes,
            ...profile.routes,
            ...license.routes,
            ...additionalItemConfigs.routes,
            ...shopCategories.routes,
            ...downloads.routes,
            ...catalogue.routes
        ],
        meta: {
            requiresAuth: true
        }
    }
]

export default routes;